import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { AuthShell } from "@/components/Layout";
import { Button } from "@/components/ui/button";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("verifying");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) {
      setState("invalid");
      return;
    }
    api.post("/auth/verify-email", { token })
      .then(() => setState("ok"))
      .catch(() => setState("invalid"));
  }, [token]);

  return (
    <AuthShell title="Email verification">
      <div className="space-y-4" data-testid="verify-email-status" data-state={state}>
        {state === "verifying" && <p className="text-sm text-muted-foreground">Verifying your email…</p>}
        {state === "ok" && (
          <>
            <p className="flex items-center gap-2 text-sm text-foreground">
              <CheckCircle2 className="h-4 w-4 text-primary" /> Your email is verified.
            </p>
            <Button asChild className="w-full" data-testid="verify-continue-button">
              <Link to="/setup">Continue setup</Link>
            </Button>
          </>
        )}
        {state === "invalid" && (
          <>
            <p className="flex items-center gap-2 text-sm text-destructive">
              <XCircle className="h-4 w-4" /> This verification link is invalid or has expired.
            </p>
            <Button asChild variant="outline" className="w-full" data-testid="verify-goto-signin-button">
              <Link to="/login">Sign in to request a new link</Link>
            </Button>
          </>
        )}
      </div>
    </AuthShell>
  );
}
